import React, { useEffect, useState } from "react";
import useAssignedStore from "./assigned_tickets/store";
import { get, isEmpty } from "lodash";
import CardDiv from "modules/common/card-div/CardDiv";
import { Select } from "antd/lib";
import { categoryMap, statusOptionsTicketStats, subCategoryMap } from "modules/navbar/top/helper";
import { useCategoryData } from "pages/store";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import { MEDICAL_ESCALATION_TICKET_ID, isDownloadDisabled } from "modules/utilities/utility";
import MedicalEscalationTable from './MedicalEscalationTable';
import { Space, Button, Pagination } from 'antd';
import _ from 'lodash';
import useAllTicketStore from './all_tickets/store';
import { toast } from 'react-toastify';
import secureLocalStorage from 'react-secure-storage';
import { getMaxDate, getMinDate } from "modules/utilities/utility";


function MedicalEscalationTickets() {
  const { bulkTicketUpdated } = useAllTicketStore();
  const { categorySubcatData, fetchCategoryData } = useCategoryData();
  const { getMedicalEscalationTickets, medEscResponse, medEscResponseLoading, getDownloadMedicalEscalationTickets, medEscResponseDownload, getDownloadMedicalEscalationPrescription, medEscPrescDownload} = useAssignedStore();
  const [page, setPage] = useState(1);
  const [subCatKey, setSubCatKey] = useState("");
  const [status, setSelectedStatus] = useState("");
  const [newAssignee, setNewAssignee] = useState();
  const [selectedUser, setSelectedUser] = useState("");
  const [currentAssignees, steCurrentAssignees] = useState([]);
  const date = new Date();
  const [endDate, setEndDate] = useState(new Date());
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [startDate, setStartDate] = useState(date.setDate(date.getDate() - 7));

  useEffect(() => { getMedicalTickets(); }, [page]);
  useEffect(() => { fetchCategoryData(); }, []);
  useEffect(() => { if (medEscResponse && medEscResponse.currentAssignee) { steCurrentAssignees(medEscResponse.currentAssignee); } }, [medEscResponse]);

  const userOptions = currentAssignees;
  const medicalEscSubCat = categorySubcatData?.data?.subcategory[MEDICAL_ESCALATION_TICKET_ID];
  const medicalEscSubCatOptions = medicalEscSubCat?.map((eachSubCat) => ({ label: eachSubCat?.label, value: eachSubCat?.key }));

  const handleUserChange = (user) => setSelectedUser(user);
  const getMedicalTickets = () => {
    getMedicalEscalationTickets(page, status, subCatKey, selectedUser, startDate, endDate)
    getDownloadMedicalEscalationTickets(status, subCatKey, selectedUser, startDate, endDate);
    getDownloadMedicalEscalationPrescription(startDate, endDate);
  };
  const handleSubCatChange = (selectedSubCats) => {
    if (selectedSubCats && selectedSubCats.length > 0) {
      const foundObjects = medicalEscSubCat?.filter((obj) => selectedSubCats.includes(obj?.key));
      const subCatKeys = foundObjects.map((foundObj) => foundObj?.key);
      setSubCatKey(subCatKeys);
    } else { setSubCatKey([]); }
  };
  const handleApplyFilters = () => {
    getMedicalEscalationTickets(page, status, subCatKey, selectedUser, startDate, endDate);
    getDownloadMedicalEscalationTickets(status, subCatKey, selectedUser, startDate, endDate);
    getDownloadMedicalEscalationPrescription(startDate, endDate);
    setPage(1);
  };

  const extractCallDetails = (ticket) => {
    const normalStart = _.get(ticket, ['medicalEngagementsActivity', 0, 'attempts', 0, 'attempt_start'], 0);
    const start = _.get(ticket, ['activity', 'attempts', 0, 'exotel_attempt_details', 'start_time'], normalStart);
    const startTime = start ? moment(start).format('DD/MM/YYYY HH:mm:ss') : 'N/A';

    const normalEnd = _.get(ticket, ['medicalEngagementsActivity', 0, 'attempts', 0, 'attempt_end'], 0);
    const end = _.get(ticket, ['activity', 'attempts', 0, 'exotel_attempt_details', 'end_time'], normalEnd);
    const endTime = end ? moment(end).format('DD/MM/YYYY HH:mm:ss') : 'N/A';

    const duration = _.get(ticket, ['medicalEngagementsActivity', 0, 'attempts', 0, 'duration'], 0);
    const durationTime = duration ? `${moment.utc(duration * 1000).format('HH:mm:ss')} Hours` : 'N/A';
    return { start: startTime, end: endTime, duration: durationTime };
  }

  const downloadCSV = async () => {
    if (medEscResponseDownload.tickets) {
      try {
        const headers = ["CustomerName", "Orded Id", "Current Assignemnt", "Priority", "Ticket Id", "Category", "SubCategory", "Status", "CreatedAt", "UpdatedAt", "Duedate", "Author", "SlotTime", "Doctor Slot Time", "Ticket Assignment", "CallStartTime", "CallEndTime", "Unanswered_Count", "Over Due", "medicalSlotFinished", "SlotCallCompleted"];
        const csvData = [
          headers,
          ...medEscResponseDownload.tickets.map((ticket) => {
            const customer_name = _.get(ticket, ['customer', 'first_name'], '');
            const current_assignment_name = _.get(ticket, ['current_assignment', 'first_name'], '');
            const order_display_id = _.get(ticket, ['source_meta', 'order_display_id'], '-');
            const medical_slot_assignment = _.get(ticket, 'medical_slot_assignment', 'N/A');
            const priority = _.get(ticket, 'priority', '');
            const category = categoryMap[_.get(ticket, 'category', '')];
            const sub_category = _.get(subCategoryMap, ticket.sub_category, ticket.sub_category);
            const ticketStatus = _.get(ticket, 'status', '');
            const status = ticketStatus;
            const ticket_created_at = `"${moment(ticket.createdAt).format("YYYY-MM-DD HH:mm:ss")}"`
            const ticket_updated_at = `"${moment(ticket.updatedAt).format("YYYY-MM-DD HH:mm:ss")}"`
            const dueDate = _.get(ticket, ['provider_meta', 'due_date'], null);
            const due_date = dueDate ? `"${moment(dueDate).format("YYYY-MM-DD HH:mm:ss")}"` : 'N/A';
            const author = _.get(ticket, ['author', 'first_name'], '');
            const medicalEngagementReminderDate = _.get(ticket, ['medicalEngagements', 0, 'reminder_date'], null);
            const slot_time = medicalEngagementReminderDate ? `"${moment(medicalEngagementReminderDate).format("YYYY-MM-DD HH:mm:ss")}"` : '-'
            const doctor_slot_time = `"${_.get(ticket, 'doctorSlotTime', 'N/A')}"`;
            const callDetails = extractCallDetails(ticket);
            const call_start_time = `"${_.get(callDetails, ['start'], '')}"`;
            const call_end_time = `"${_.get(callDetails, ['end'], '')}"`;
            const unanswered_count = _.get(ticket, ['medicalEngagements', 0, 'unanswered_count'], '-');
            const over_due = slot_time ? moment(slot_time).isBefore(moment()) ? 'Yes' : 'No' : 'N/A';
            const medicalSlotFinished = _.get(ticket, ['medicalEngagements', 0, 'is_finished'], false);
            const operationStatus = _.get(ticket, ['medicalEngagements', 0, 'operation_status'], null);
            const medicalStatus = _.get(ticket, ['medicalEngagements', 0, 'status'], null);
            let slot_call_completed ='';

            if (medicalStatus === 'active') {
              if (unanswered_count < 1) {
                slot_call_completed = 'not attempted';
              } else {
                slot_call_completed = 'unanswered';
              }
            } else {
              if (['auto_completed', 'system_completed'].includes(operationStatus)) {
                slot_call_completed = 'unanswered';
              } else if (!operationStatus || operationStatus === 'completed' ) {
                slot_call_completed = 'answered';
              }
            }
            return [customer_name, order_display_id, medical_slot_assignment, priority, ticket._id, category, sub_category, status, ticket_created_at, ticket_updated_at, due_date, author, slot_time, doctor_slot_time, current_assignment_name, call_start_time, call_end_time, unanswered_count, over_due, medicalSlotFinished, slot_call_completed];

          }),
        ];

        const csvContent = csvData.map((row) => row.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `medical_escalation_tickets_${moment.now()}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (error) {
        toast.error('Failed to download file');
        console.error("Error converting to CSV:", error);
      }
    }
  };

  const ensureArray = (field) => (Array.isArray(field) ? field : [field]);

const prescriptionHeaders = (prescriptionLength, doctorLength) => {
    const headers = [
        "_id", "case_id", "category", "customer.id", "customer.first_name", "customer.email", "customer.phone_number", "__v", "createdAt", "updatedAt", "order_display_id", "customer.user_id", "customer.user_meta.ad_id", "customer.user_meta.sdpFinished"
    ];

  const prescriptionHeaders = Array.from({ length: prescriptionLength }).map((_, i) => ([
    `prescription[${i}].test`,
    `prescription[${i}].prescription`,
    `prescription[${i}].dosage`,
    `prescription[${i}].comment`,
    `prescription[${i}].external`,
    `prescription[${i}].medicine`
  ])).flat();

  const doctorHeaders = Array.from({ length: doctorLength }).map((_, i) => ([
    `doctor[${i}].user_id`,
    `doctor[${i}].first_name`,
    `doctor[${i}].email`,
    `doctor[${i}].phone_number`
  ])).flat();

return headers.concat(prescriptionHeaders, doctorHeaders);
};

const mapToCSVRow = (item, prescriptionLength, doctorLength) => {
  const row = [
    `"${item._id}"`,
    `"${item.case_id}"`,
    `"${item.category}"`,
    `"${get(item, 'customer.id', 'N/A')}"`,
    `"${get(item, 'customer.first_name', 'N/A')}"`,
    `"${get(item, 'customer.email', 'N/A')}"`,
    `"${get(item, 'customer.phone_number', 'N/A')}"`,
    `"${item.__v}"`,
    `"${moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}"`,
    `"${moment(item.updatedAt).format("YYYY-MM-DD HH:mm:ss")}"`,
    `"${get(item, 'order_display_id', 'N/A')}"`,
    `"${get(item, 'customer.user_id', 'N/A')}"`,
    `"${get(item, 'customer.user_meta.ad_id', 'N/A')}"`,
    `"${get(item, 'customer.user_meta.sdpFinished', 'N/A')}"`
  ];

  const prescriptionData = Array.from({ length: prescriptionLength }).map((_, i) => ([
    `"${get(item, `prescription[${i}].test`, 'N/A')}"`,
    `"${get(item, `prescription[${i}].prescription`, 'N/A')}"`,
    `"${get(item, `prescription[${i}].dosage`, 'N/A')}"`,
    `"${get(item, `prescription[${i}].comment`, 'N/A')}"`,
    `"${get(item, `prescription[${i}].external`, 'N/A')}"`,
    `"${get(item, `prescription[${i}].medicine`, 'N/A')}"`
  ])).flat();


  const doctorData = Array.from({ length: doctorLength }).map((_, i) => ([
    `"${get(item, `doctor[${i}].user_id`, 'N/A')}"`,
    `"${get(item, `doctor[${i}].first_name`, 'N/A')}"`,
    `"${get(item, `doctor[${i}].email`, 'N/A')}"`,
    `"${get(item, `doctor[${i}].phone_number`, 'N/A')}"`
  ])).flat();

return row.concat(prescriptionData, doctorData);
};

const downloadPrescriptionCSV = async () => {
    if (!medEscPrescDownload.length) return;

    try {
      medEscPrescDownload.forEach(item => {
        item.prescription = ensureArray(item.prescription);
        item.doctor = ensureArray(item.doctor);
    });

    const prescriptionLength = Math.max(
      ...medEscPrescDownload.map(item => (item.prescription ? item.prescription.length : 0))
  );
  
  const doctorLength = Math.max(
      ...medEscPrescDownload.map(item => (item.doctor  ? item.doctor.length : 0))
  );
  console.log(prescriptionLength)
    const headers = prescriptionHeaders(prescriptionLength, doctorLength);
    const dataToCSV = medEscPrescDownload.map(item => mapToCSVRow(item, prescriptionLength, doctorLength));
    
    const csvContent = [headers, ...dataToCSV].map(row => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `medical_escalation_prescription_${moment().format("YYYYMMDD_HHmmss")}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
 } catch (error) {
  toast.error('Failed to download file');
  console.error("Error converting to CSV:", error);
}
};

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };
  const updateTicket = async () => {
    await bulkTicketUpdated({ ticketIds: selectedRowKeys, current_assignment: newAssignee, action_taker: secureLocalStorage.getItem('id') });
    getMedicalTickets();
    setSelectedRowKeys();
    setNewAssignee();
  }
  return (
    <>
      <CardDiv
        title={
          <div className="d-flex gap-1 justify-content-between">
            <div className="fs-2">Medical Escalation Tickets</div>
            <Button
                type="primary"
                onClick={downloadPrescriptionCSV}
                className="mb-3"
                style={{ marginLeft: "2px" }}
                 disabled={isDownloadDisabled && isEmpty(medEscPrescDownload)}
              >
                PrescriptionDownload
              </Button>
          </div>
        }
        component={
          <>
            <div className='d-flex justify-content-end gap-2'>
              <Select
                className="mb-3 mr-3"
                allowClear
                placeholder="Status"
                style={{ width: "250px" }}
                options={statusOptionsTicketStats}
                onChange={(status) => { setSelectedStatus(status) }}
                onClear={() => { setSelectedStatus("") }}
                showSearch
                mode="multiple"
              />
              <Select
                className="mb-3 mr-3"
                allowClear
                placeholder="Sub Categories"
                style={{ width: "250px", marginLeft: "2px" }}
                options={medicalEscSubCatOptions}
                onChange={(event) => handleSubCatChange(event)}
                onClear={() => { setSubCatKey("") }}
                showSearch
                mode="multiple"
              />
              <Select
                className="mb-3 mr-3"
                allowClear
                placeholder="Ticket Assignee"
                style={{ width: "250px", marginLeft: "2px" }}
                options={userOptions}
                onChange={(user) => handleUserChange(user)}
                onClear={() => setSelectedUser("")}
                showSearch
                mode="multiple"
              />
              <div style={{ width: "200px" }}>
                <ReactDatePicker
                  selected={startDate}
                  onChange={onChange}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  dateFormat="MMM dd"
                  className="form-control mb-3 mr-3"
                  minDate={getMinDate(endDate)}
                  maxDate={getMaxDate(startDate)}                
                />
              </div>
              <Button
                type="primary"
                onClick={handleApplyFilters}
                className="mb-3"
                style={{ marginLeft: "2px" }}
              >
                Apply Filters
              </Button>
              <Button
                type="primary"
                onClick={downloadCSV}
                className="mb-3"
                style={{ marginLeft: "2px" }}
                disabled={isDownloadDisabled || isEmpty(medEscResponseDownload.tickets)}              >
                Download
              </Button>           
              <Space.Compact>
                <Select
                  allowClear
                  placeholder="Select Ticket Assignee"
                  style={{ width: "250px" }}
                  options={userOptions}
                  onChange={(user) => setNewAssignee(user)}
                  showSearch
                />
                <Button type='primary'
                  disabled={(_.size(selectedRowKeys) === 0 || !newAssignee)}
                  onClick={() => { updateTicket() }}>Assign</Button>
              </Space.Compact>
            </div>
            <MedicalEscalationTable tickets={medEscResponse?.tickets} pagination={medEscResponse?.pagination} setSelectedRowKeys={setSelectedRowKeys} selectedRowKeys={selectedRowKeys} medEscResponseLoading={medEscResponseLoading} extractCallDetails={extractCallDetails} />
            <div className='d-flex justify-content-center mt-4'>
              <Pagination defaultCurrent={1} total={medEscResponse?.pagination?.totalTickets} onChange={(page) => setPage(page)} block />
            </div>

          </>
        }
      />
    </>
  );
}

export default MedicalEscalationTickets;
